<table class="table table-striped">
  <thead>
    <tr>
      <th scope="col" width="1%">

      </th>
      <th scope="col" width="27%">
        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.TabelaVinculos.EntidadeOriginal' | translate}}
        <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="{{'Tooltips.ContagemTempoExSubs.Designacao' | translate}}" container="body"></span>
      </th>
      <th scope="col" width="10%">
        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.TabelaVinculos.LocalidadeDistrito' | translate}}<br />
        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.TabelaVinculos.EntidadeOriginal' | translate}}
      </th>
      <th scope="col" width="12%">
        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.TabelaVinculos.Situacao' | translate}}<br />
        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.TabelaVinculos.EntidadeOriginal' | translate}}
      </th>
      <th scope="col"  width="27%" style="border-right: 1px">
        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.TabelaVinculos.EntidadeAtual' | translate}}
      </th>
      <th scope="col" width="10%">
        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.TabelaVinculos.LocalidadeDistritoAtual' | translate}}<br />
        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.TabelaVinculos.EntidadeAtual' | translate}}
      </th>
      <th scope="col" width="12%">
        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.TabelaVinculos.SituacaoAtual' | translate}}<br />
        {{'WorkflowCreate.ContagemTempoExSubs.Steps.IdentificacaoServico.Opcoes.TabelaVinculos.EntidadeAtual' | translate}}
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let tableItem of subscriberServices; let i = index">
      <tr [style.backgroundColor]="isItemValid(tableItem)
          ? ' var(--bs-table-striped-bg) !important' : 'inherit'" *ngIf="!(tableItem.estado == 'D' && tableItem.servIntegracoesList?.length > 0 && (tableItem.servInicialChave == null || tableItem.servInicialChave == undefined )) " [ngClass]="tableItem.chaveServico === chaveServicoEscolhido && tableItem.servInicialChave === finalService?.servInicialChave  ? 'text-primary table-active-top-border' : 'enabled'">
        <td>
          <input aria-controls="collapseManual"
                 class="escolhaVinculo1"
                 type="radio"
                 name="Escolha1_{{i}}"
                 id="Escolha1_{{i}}"
                 [attr.alt]="tableItem.chaveServico + tableItem.servInicialChave"
                 [disabled]="isEnabled === false
                            || tableItem.estado === 'D'
                            || (tableItem.estado == 'A' &&
                                  (
                                    (tableItem.registadoCGADIR == '0' && tableItem.numSubsAtivos == '0')
                                    || (tableItem.registadoCGADIR == '0')
                                    || (tableItem.numSubsAtivos == '0')
                                  )
                                )"
                 (change)="optionClicked(tableItem,i)">
        </td>

        <!-- designacao serviço origem-->
        <td >
          <span *ngIf="tableItem.servInicialChave !== null && tableItem.servInicialChave !== undefined">
            {{tableItem.servInicialDesignacao}}
          </span>
          <span *ngIf="tableItem.servInicialChave == null || tableItem.servInicialChave == undefined">
            {{tableItem.designacao}}
          </span>
        </td>
        <!-- localidade/distrito origem   *ngIf="tableItem.servInicialLocalidade != null && tableItem.servInicialDistrito != null"  -->
        <td>
          <span *ngIf="tableItem.servInicialChave !== null && tableItem.servInicialChave !== undefined">
            {{tableItem.servInicialLocalidade !== null ? tableItem.servInicialLocalidade + ' / ' + tableItem.servInicialDistrito : ''}}
          </span>
          <span *ngIf="tableItem.servInicialChave == null || tableItem.servInicialChave == undefined">
            {{tableItem.localidade !== null ? tableItem.localidade + ' / ' + tableItem.distrito : ''}}
          </span>
        </td>
        <!-- estado serviço origem-->
        <td>
          <span>
            {{getTableItemEstado(tableItem, tableItem.servInicialEstado !== null && tableItem.servInicialEstado !== undefined )}}
          </span>
          <!-- TODO melhorar esta tooltip -->
          <span *ngIf="getTableItemEstado(tableItem, tableItem.servInicialEstado !== null && tableItem.servInicialEstado !== undefined ) === 'Não elegível'"
                tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Serviço ativo, não elegível para seleção, por não reunir, neste momento, condições para preenchimento de pedido."
                container="body" ></span>

        </td>

        <!-- propriedades serviço atual-->
        <td>
          <span *ngIf="tableItem.servInicialChave !== null && tableItem.servInicialChave !== undefined">
            {{tableItem.designacao}}
          </span>
        </td>
        <td >
          <span *ngIf="tableItem.servInicialChave !== null && tableItem.servInicialChave !== undefined">
            {{tableItem.localidade + ' / ' + tableItem.distrito}}
          </span>
        </td>
        <td>
          <span *ngIf="tableItem.servInicialChave !== null && tableItem.servInicialChave !== undefined">
            {{getTableItemEstado(tableItem, false)}}
          </span>
          <span *ngIf="tableItem.servInicialChave !== null && tableItem.servInicialChave !== undefined && getTableItemEstado(tableItem, false) === 'Não elegível'"
                tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" tooltip="Serviço ativo, mas não elegível para seleção, por não reunir, neste momento, condições para preenchimento de pedido."
                container="body" ></span>

        </td>

      </tr>
    </ng-container>
  </tbody>
</table>
